import {
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LoaderComponent implements AfterViewInit {
  @ViewChild('loaderTemplate') loaderTemplate!: TemplateRef<unknown>;

  private overlayRef: OverlayRef | null = null;

  private readonly destroyRef = inject(DestroyRef);
  private readonly overlay = inject(Overlay);
  private readonly viewContainerRef = inject(ViewContainerRef);

  constructor(private readonly loaderService: LoaderService) {}

  ngAfterViewInit(): void {
    this.loaderService
      .getLoader()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((show) => {
        if (show) {
          this.open();
        } else {
          this.close();
        }
      });

    this.destroyRef.onDestroy(() => {
      this.close();
    });
  }

  private open(): void {
    if (this.overlayRef) {
      return;
    }

    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'app-global-loader-backdrop',
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block()
    });

    this.overlayRef.attach(
      new TemplatePortal(this.loaderTemplate, this.viewContainerRef)
    );
  }

  private close(): void {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }
}
